module.exports = __webpack_public_path__ + "static/img/2.8894ac6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/2.png
// module id = bgkY
// module chunks = 0